import { cn } from "@/lib/utils";

interface DotProps {
  color?: string;
}

export const Dot = ({ color = "bg-dark-tertiary" }: DotProps) => (
  <div className={cn("size-1 rounded-full shrink-0", color)} />
);
